import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { apiService, setupInterceptors } from '../services/apiService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AuthContext } from '../context/AuthContext';
import logo from '../images/logo_1.png'
import '../styles/Presupuesto.css'

const PresupuestoDetalle = () => {
    const { id } = useParams(); // Obtenemos el id de la URL
    const [presupuesto, setPresupuesto] = useState(null); // Estado para almacenar los datos del presupuesto
    const [loading, setLoading] = useState(true); // Estado para manejar el loading
    const { logoutUser } = useContext(AuthContext);

    useEffect(() => {
        const handlePrintShortcut = (e) => {
            if (e.ctrlKey && e.key === 'p') {
                e.preventDefault();
                window.print();
            }
        };

        window.addEventListener('keydown', handlePrintShortcut);
        
        // Limpia el evento cuando el componente se desmonta
        return () => {
            window.removeEventListener('keydown', handlePrintShortcut);
        };
    }, []);

    useEffect(() => {
        // Función para obtener el presupuesto desde la API
        const obtenerPresupuesto = async () => {
            try {
                const response = await apiService.fetchData(`presupuestos/${id}/`)
                setPresupuesto(response.data); // Guardamos los datos del presupuesto

                setLoading(false); // Quitamos el loading
            } catch (error) {
                console.error('Error al obtener el presupuesto:', error);
                setLoading(false); // Quitamos el loading en caso de error
            }
        };
        setupInterceptors(logoutUser);
        obtenerPresupuesto();
    }, [id]); // Dependencia del id


    if (loading) {
        return <p>Cargando...</p>;
    }

    if (!presupuesto) {
        return <p>No se encontró el presupuesto.</p>;
    }

    console.log(presupuesto)

    return (
            <div id='presupuesto-detalle' style={containerStyle}>
                {/* Encabezado con Logo y Detalles del Presupuesto */}
                <div style={encabezadoStyle}>
                    {/* Logo */}
                    <div style={logoContainerStyle}>
                        <img src={logo} alt="Logo" style={logoStyle} />
                    </div>
    
                    {/* Detalles del presupuesto: Título, ID, Fecha */}
                    <div style={detallesPresupuestoStyle}>
                        <h2 style={tituloStyle}>Presupuesto</h2>
                        <p><strong>Presupuesto N°:</strong> {presupuesto.id}</p>
                        <p><strong>Fecha:</strong> {new Date(presupuesto.created_at).toLocaleDateString()}</p>
                    </div>
                </div>
    
                <div style={lineaStyle}></div>
    
                {/* Datos del Cliente */}
                <div style={clienteInfoStyle}>
                    <div style={detalleClienteStyle}>
                        <p><strong>Cliente:</strong> {presupuesto.cliente_nombre}</p>
                        <p><strong>Contacto:</strong> {presupuesto.cliente_contacto}</p>
                    </div>
                </div>
    
                {/* Tabla de Items del Presupuesto */}
                {/* DataTable de PrimeReact */}
                <DataTable value={presupuesto.items_presupuesto} responsiveLayout="scroll">
                    <Column field="codigo" header="Código" style={{ textAlign: 'center', fontSize:"15px", borderLeft:"1px solid #e5e7eb", borderBottomRightRadius:"10px" }} alignHeader={"center"}
                    headerStyle={{ backgroundColor:"#384152", color:"#fff", border:"1px solid #F1F1F1", borderTopLeftRadius:"10px" }}
                    ></Column>
                    <Column field="nombre" header="Nombre" style={{ textAlign: 'center', fontSize:"15px" }} alignHeader={"center"}
                    headerStyle={{ backgroundColor:"#384152", color:"#fff", border:"1px solid #F1F1F1" }}
                    ></Column>
                    <Column field="cantidad" header="Cantidad" style={{ textAlign: 'center', fontSize:"15px", borderRight:"1px solid #e5e7eb",
                    borderBottomLeftRadius:"10px" }} alignHeader={"center"}
                    headerStyle={{ backgroundColor:"#384152", color:"#fff", border:"1px solid #F1F1F1", borderTopRightRadius:"10px" }}
                    ></Column>
                    <Column field="precio_unitario" header="Precio Unit." style={{ textAlign: 'center', fontSize:"15px", borderRight:"1px solid #e5e7eb",
                    borderBottomLeftRadius:"10px" }} alignHeader={"center"}
                    headerStyle={{ backgroundColor:"#384152", color:"#fff", border:"1px solid #F1F1F1", borderTopRightRadius:"10px" }}
                    ></Column>
                    <Column field="total" header="Importe Total" style={{ textAlign: 'center', fontSize:"15px", borderRight:"1px solid #e5e7eb",
                    borderBottomLeftRadius:"10px" }} alignHeader={"center"}
                    headerStyle={{ backgroundColor:"#384152", color:"#fff",  borderTopRightRadius:"10px" }}
                    ></Column>
                </DataTable>

                <div className='mt-4' style={{ display:"flex", justifyContent:"center", fontSize:"22px" }}>
                    <span><b>Total: {presupuesto.monto_total_formateado}</b></span>
                </div>
            </div>
        );
    };
    
    // Estilos del contenedor general
    const containerStyle = {
        padding: '30px',
        backgroundColor: '#f9fafc',
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        color: '#333',
        maxWidth: '800px',
        margin: '0 auto',
        borderRadius: '12px',
        boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
        minHeight: '100vh'
    };
    
    // Estilo del encabezado con el logo y los detalles
    const encabezadoStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
    };
    
    // Contenedor del logo
    const logoContainerStyle = {
        flex: '1',
        display: 'flex',
        justifyContent: 'flex-start'
    };
    
    // Estilo del logo
    const logoStyle = {
        width: '150px',
        height: 'auto'
    };
    
    // Contenedor de los detalles del presupuesto
    const detallesPresupuestoStyle = {
        flex: '2',
        textAlign: 'right',
        lineHeight: '1.5',
        color: '#2c3e50'
    };
    
    // Estilo del título "Presupuesto"
    const tituloStyle = {
        fontSize: '24px',
        marginBottom: '5px',
        color: '#2c3e50'
    };
    
    // Línea decorativa debajo del encabezado
    const lineaStyle = {
        width: '100%',
        height: '2px',
        backgroundColor: '#003466',
        marginBottom: '20px'
    };
    
    // Estilo de la sección de información del cliente
    const clienteInfoStyle = {
        padding: '5px',
        borderRadius: '8px',
        marginBottom: '20px',
    };
    
    // Estilos de los detalles del cliente
    const detalleClienteStyle = {
        fontSize: '16px',
        color: '#2c3e50',
        lineHeight: '1.6'
    };
    
    // Estilo de la tabla
    const tablaStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '20px',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
    };
    
    // Estilo de la cabecera de la tabla
    const encabezadoTablaStyle = {
        backgroundColor: '#003466',
        color: '#fff',
        textAlign: 'left',
        fontWeight: 'bold'
    };
    
    // Estilo de las celdas de la cabecera
    const headerCellStyle = {
        padding: '15px',
        borderBottom: '2px solid #003466',
        textAlign:"center"
    };
    
    // Estilo de las celdas
    const cellStyle = {
        padding: '12px',
        textAlign: 'center',
        color: '#34495e',
    };
    
    // Estilo de las filas alternas
    const rowStyle = {
        backgroundColor: '#f7f9fb',
        border:"1px solid #000"
    };
    
    const alternateRowStyle = {
        backgroundColor: '#ffffff',
        border:"1px solid #000"
    };
export default PresupuestoDetalle;